import { IPlan } from "../models/plan";

export const SubsriptionPlansDevelopment: IPlan[] = [
	{
		name: "Basic",
		monthly: {
			priceId: "price_1QWmyQIDQPUeikoEiB7KwTv9",
			price: 0,
		},
		yearly: {
			priceId: "price_1QWmyQIDQPUeikoEiB7KwTv9",
			price: 0,
		},
		discount: "Test drive with free tier plan",
		features: [
			"Single User",
			"1 Chatbot",
			"100 Message credits",
			"5 Knowlege bases",
			"100 Table rows",
			"5 FAQs",
		],
		buttonText: "Get started",
	},
	{
		name: "Starter",
		monthly: {
			priceId: "price_1QMehtIDQPUeikoEmL2JHHJb",
			price: 19.99,
		},
		yearly: {
			priceId: "price_1QMfUGIDQPUeikoEafcd9vpI",
			price: 192,
		},
		discount: "Save 20% on yearly plan",
		features: [
			"2 Users",
			"2 Chatbots",
			"3K Message credits (monthly)",
			"10 Knowlege bases",
			"2000 Table rows",
			"10 FAQs",
		],
		buttonText: "Subscribe",
	},
	{
		name: "Pro",
		monthly: {
			priceId: "price_1QMf1GIDQPUeikoEWxvRPXy3",
			price: 69.99,
		},
		yearly: {
			priceId: "price_1QMfVRIDQPUeikoEFUAeaYp5",
			price: 758,
		},
		discount: "Save $70 on yearly plan",
		features: [
			"5 Users",
			"5 Chatbots",
			"20K Message credits (monthly)",
			"50 Knowlege bases",
			"6,000 Table rows",
			"50 FAQs",
		],
		buttonText: "Subscribe",
	},
	{
		name: "Business",
		monthly: {
			priceId: "price_1QMf74IDQPUeikoE7PDBUnJO",
			price: 299,
		},
		yearly: {
			priceId: "price_1QMfXbIDQPUeikoE3p0pdMNK",
			price: 3288,
		},
		discount: "Save $300 on yearly plan",
		features: [
			"100 Users",
			"20 Chatbots",
			"50K Message credits (Monthly)",
			"200 Knowlege bases",
			"20,000 Table rows",
			"200 FAQs",
		],
		buttonText: "Subscribe",
	},
];

export const SubsriptionPlansProduction: IPlan[] = [
	{
		name: "Basic",
		monthly: {
			priceId: "price_1Qj7Q0IDQPUeikoE24gmfqTa",
			price: 0,
		},
		yearly: {
			priceId: "price_1Qj7Q0IDQPUeikoE24gmfqTa",
			price: 0,
		},
		discount: "Test drive with free tier plan",
		features: [
			"Single User",
			"1 Chatbot",
			"100 Message credits",
			"5 Knowlege bases",
			"100 Table rows",
			"5 FAQs",
		],
		buttonText: "Get started",
	},
	{
		name: "Starter",
		monthly: {
			priceId: "price_1Qj7QHIDQPUeikoEIoV2BTl9",
			price: 19.99,
		},
		yearly: {
			priceId: "price_1Qj7QHIDQPUeikoE8ooaWp3N",
			price: 192,
		},
		discount: "Save 20% on yearly plan",
		features: [
			"2 Users",
			"2 Chatbots",
			"3K Message credits (monthly)",
			"10 Knowlege bases",
			"2000 Table rows",
			"10 FAQs",
		],
		buttonText: "Subscribe",
	},
	{
		name: "Pro",
		monthly: {
			priceId: "price_1Qj7QCIDQPUeikoEZO95n1Fs",
			price: 69.99,
		},
		yearly: {
			priceId: "price_1Qj7QCIDQPUeikoEK2ibLfyA",
			price: 758,
		},
		discount: "Save $70 on yearly plan",
		features: [
			"5 Users",
			"5 Chatbots",
			"20K Message credits (monthly)",
			"50 Knowlege bases",
			"6,000 Table rows",
			"50 FAQs",
		],
		buttonText: "Subscribe",
	},
	{
		name: "Business",
		monthly: {
			priceId: "price_1Qj7Q7IDQPUeikoEy3rSm2z6",
			price: 299,
		},
		yearly: {
			priceId: "price_1Qj7Q7IDQPUeikoEeUpI6r6A",
			price: 3288,
		},
		discount: "Save $300 on yearly plan",
		features: [
			"100 Users",
			"20 Chatbots",
			"50K Message credits (Monthly)",
			"200 Knowlege bases",
			"20,000 Table rows",
			"200 FAQs",
		],
		buttonText: "Subscribe",
	},
];

export const EnterprisePlan: IPlan = {
	name: "Enterprise",
	monthly: {
		priceId: "",
		price: 299,
	},
	yearly: {
		priceId: "",
		price: 3288,
	},
	discount: "Save $300 on yearly plan",
	features: [
		"Unlimited Users",
		"100+ Chatbots",
		"Unlimited Message credits",
		"500+ Knowlege bases",
		"100K+ Table rows",
		"500+ FAQs",
	],
	additionalFeatures: [
		"2X faster request",
		"Priority support",
		"Custom onboarding",
		"Custom API"
	],
	buttonText: "Subscribe",
}; 

export const SubscriptionPlans = process.env.NODE_ENV === "development" ? 
	SubsriptionPlansDevelopment : SubsriptionPlansProduction;